import { fetchJSON, fetchWithAuth } from "../../util/fetch-utils";
import { VelavuRequestError } from "../../error/error";
export class MappedinCredentialsError extends VelavuRequestError {
    constructor(originalError) {
        super(originalError.statusCode, originalError.raw);
        this.name = "MappedinCredentialsError";
    }
}
export default class VelavuAPIMappedin {
    /**
     * This method stores the MappedIn credentials in Velavu's backend, enabling the MappedIn Integration.
     */
    addIntegration(params) {
        return fetchJSON("/integrations/mappedin", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(params),
        }).catch((error) => {
            //Wrap errors in MappedinCredentialsError
            if (error instanceof VelavuRequestError && error.reason === "ERR_INVALID_MP_TOKEN") {
                throw new MappedinCredentialsError(error);
            }
            else {
                throw error;
            }
        });
    }
    ;
    /**
     * This method deletes the MappedIn credentials in Velavu's backend, removing the MappedIn Integration.
     */
    removeIntegration() {
        return fetchWithAuth("/integrations/mappedin", {
            method: "DELETE",
        });
    }
    /**
     * This method queries the MappedIn API and returns a list of MappedIn venues.
     */
    getVenues() {
        return fetchJSON("/integrations/mappedin/venues");
    }
    /**
     * This method imports a MappedIn venue as a Velavu site.
     */
    importVenue(venueID) {
        return fetchJSON(`/integrations/mappedin/venues/${venueID}/import`, {
            method: "POST",
        });
    }
    /**
     * This method disconnects a previously imported venue from its Velavu site.
     */
    disconnectVenue(venueID) {
        return fetchWithAuth(`/integrations/mappedin/venues/${venueID}/disconnect`, {
            method: "POST",
        });
    }
}
//# sourceMappingURL=velavu-api-mappedin.js.map